module.exports = __webpack_public_path__ + "static/media/importFile.e8a2336c.svg";